import { sellerCard as baseSellerCard } from '../../../listing/cards';
import { applyOverrides } from '../../../shared';

export const sellerCard = applyOverrides(baseSellerCard, {
  innerTitle: 'Landlord x',
  outerTitle: 'Landlords',
  addableTitle: 'Landlord x',
  addText: 'Landlord',
});
